"use client";
import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { ClientConfig, GenericConfig } from ".";

export const buildProvider = <T extends GenericConfig>() => {
  const clientConfigContext = createContext<ClientConfig<T> | undefined>(
    undefined,
  );

  const Provider = clientConfigContext.Provider;

  const useConfig = () => useContext(clientConfigContext);
  const ClientConfigProvider = ({
    children,
    config,
  }: {
    children: ReactNode;
    config: ClientConfig<T>;
  }) => <Provider value={config}>{children}</Provider>;

  return {
    ClientConfigProvider,
    useConfig,
  };
};
